import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_PRODUCT_QUERY_KEY } from './useGetProduct';
import { GET_PRODUCTS_QUERY_KEY } from './useGetProducts';

import ProductsService from '@/services/ProductsService';

export function useRecreateProductName(catalogId: number) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: () => ProductsService.recreateProductName(catalogId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_PRODUCTS_QUERY_KEY(),
      });

      queryClient.invalidateQueries({
        queryKey: GET_PRODUCT_QUERY_KEY(catalogId),
      });
    },
  });

  return {
    recreateProductName: mutateAsync,
    isLoading: isPending,
  };
}
